/*
 * Mobile - Homepage - Menu Fixes  --  variant: Menu Fixes No Menu On Load
 * Moonshot experiment id: 37946231   status in Moonshot on 2026-08-27: DEPLOYED   started: 2025-08-27
 * Audience: MOBILE   Target: homepage   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_home_m_menu_fixes
 */
MGExp.run('home_m_menu_fixes', { name: "Mobile - Homepage - Menu Fixes / Menu Fixes No Menu On Load", platform: 'mobile', target: 'homepage' }, function () {
  !(function () {
    let o = [],
      t = [];
    !(async function (n, e, a, i, s) {
      let m = {
        multi_target_selectors: o,
        page_identifier_selector: "body.template-index",
        exclude_from_timeout: t,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(n, e, a, i, s, m);
    })(
      ["#mobile-secondary-nav.bottom-part"],
      ".msai-no-menu-on-load",
      function (o, t) {
        const [n] = t;
        n.classList.add("msai-no-menu-on-load");
      },
      ".msai-no-menu-on-load{display:none !important}body{padding-top:97px !important}",
    );
  })();
});
